import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import Loader from "../Loader/Loader";

const PaymentTypes = (props) => {
  const [visiblePaymentTypes, setVisiblePaymentTypes] = useState(false);
  const [comingPaymentTypes, setcomingPaymentTypes] = useState(
    props.visiblePaymentTypesChange
  );
  const [disableCash, setDisableCash] = useState(false);
  const [disableCheck, setDisableCheck] = useState(false);
  const [disableGiftCard, setDisableGiftCard] = useState(false);
  const [disableDebitCard, setDisableDebitCard] = useState(false);
  const [disableCreditCard, setDisableCreditCard] = useState(false);
  const [formValues, setFormValues] = useState({
    PaymentTypes: "",
    CashMarkupMarkdownPercentage: "",
    CheckMarkupMarkdownPercentage: "",
    GiftCardMarkupMarkdownPercentage: "",
    DebitCardMarkupMarkdownPercentage: "",
    CreditCardMarkupMarkdownPercentage: "",
    StoreAccountMarkupMarkdownPercentage: "",
    PointsMarkupMarkdownPercentage: "",
    DefaultPaymentType: "",
    DefaultPaymentTypeForReceivings: "",
    ShowSellingPriceOnReceivingReceipt: false,
    EnableEBTPayments: false,
    EnableWIC: false,
    PromptForCCVWhenSwipingCreditCard: false,
  });
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("Token");

  const handleSubmit = (values) => {
    const formArray = [
      { AppConfigkey: "PaymentTypes", AppConfigvalue: values.PaymentTypes },
      {
        AppConfigkey: "CashMarkupMarkdownPercentage",
        AppConfigvalue: values.CashMarkupMarkdownPercentage,
      },
      {
        AppConfigkey: "CheckMarkupMarkdownPercentage",
        AppConfigvalue: values.CheckMarkupMarkdownPercentage,
      },
      {
        AppConfigkey: "GiftCardMarkupMarkdownPercentage",
        AppConfigvalue: values.GiftCardMarkupMarkdownPercentage,
      },
      {
        AppConfigkey: "DebitCardMarkupMarkdownPercentage",
        AppConfigvalue: values.DebitCardMarkupMarkdownPercentage,
      },
      {
        AppConfigkey: "CreditCardMarkupMarkdownPercentage",
        AppConfigvalue: values.CreditCardMarkupMarkdownPercentage,
      },
      {
        AppConfigkey: "StoreAccountMarkupMarkdownPercentage",
        AppConfigvalue: values.StoreAccountMarkupMarkdownPercentage,
      },
      {
        AppConfigkey: "PointsMarkupMarkdownPercentage",
        AppConfigvalue: values.PointsMarkupMarkdownPercentage,
      },
      {
        AppConfigkey: "DefaultPaymentType",
        AppConfigvalue: values.DefaultPaymentType,
      },
      {
        AppConfigkey: "DefaultPaymentTypeForReceivings",
        AppConfigvalue: values.DefaultPaymentTypeForReceivings,
      },
      {
        AppConfigkey: "ShowSellingPriceOnReceivingReceipt",
        AppConfigvalue: values.ShowSellingPriceOnReceivingReceipt,
      },
      {
        AppConfigkey: "EnableEBTPayments",
        AppConfigvalue: values.EnableEBTPayments,
      },
      { AppConfigkey: "EnableWIC", AppConfigvalue: values.EnableWIC },
      {
        AppConfigkey: "PromptForCCVWhenSwipingCreditCard",
        AppConfigvalue: values.PromptForCCVWhenSwipingCreditCard,
      },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "PAYMENT_TYPES",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  const handlePayment = () => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=PAYMENT_TYPES`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "PaymentTypes") {
            formValues.PaymentTypes = data.AppConfigvalue;
          } else if (data.AppConfigkey === "CashMarkupMarkdownPercentage") {
            formValues.CashMarkupMarkdownPercentage = data.AppConfigvalue;
          } else if (data.AppConfigkey === "CheckMarkupMarkdownPercentage") {
            formValues.CheckMarkupMarkdownPercentage = data.AppConfigvalue;
          } else if (data.AppConfigkey === "GiftCardMarkupMarkdownPercentage") {
            formValues.GiftCardMarkupMarkdownPercentage = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "DebitCardMarkupMarkdownPercentage"
          ) {
            formValues.DebitCardMarkupMarkdownPercentage = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "CreditCardMarkupMarkdownPercentage"
          ) {
            formValues.CreditCardMarkupMarkdownPercentage = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "StoreAccountMarkupMarkdownPercentage"
          ) {
            formValues.StoreAccountMarkupMarkdownPercentage =
              data.AppConfigvalue;
          } else if (data.AppConfigkey === "PointsMarkupMarkdownPercentage") {
            formValues.PointsMarkupMarkdownPercentage = data.AppConfigvalue;
          } else if (data.AppConfigkey === "DefaultPaymentType") {
            formValues.DefaultPaymentType = data.AppConfigvalue;
          } else if (data.AppConfigkey === "DefaultPaymentTypeForReceivings") {
            formValues.DefaultPaymentTypeForReceivings = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "ShowSellingPriceOnReceivingReceipt"
          ) {
            formValues.ShowSellingPriceOnReceivingReceipt =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableEBTPayments") {
            formValues.EnableEBTPayments =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableWIC") {
            formValues.EnableWIC =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "PromptForCCVWhenSwipingCreditCard"
          ) {
            formValues.PromptForCCVWhenSwipingCreditCard =
              data.AppConfigvalue === "false" ? false : true;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleDisableCash = () => {
    setDisableCash(!disableCash);
  };

  const handleDisableCheck = () => {
    setDisableCheck(!disableCheck);
  };

  const handleDisableGiftCard = () => {
    setDisableGiftCard(!disableGiftCard);
  };

  const handleDisableDebitCard = () => {
    setDisableDebitCard(!disableDebitCard);
  };

  const handleDisableCreditCard = () => {
    setDisableCreditCard(!disableCreditCard);
  };

  const data = [
    {
      name: "Payment Types:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="mb-3" style={{ width: "max-content" }}>
              <button
                type="button"
                className={`btn btn-sm me-1 ${
                  disableCash === true ? " btn-primary" : " btn-secondary"
                }`}
                onClick={handleDisableCash}
              >
                Cash
              </button>
              <button
                type="button"
                className={`btn btn-sm me-1 ${
                  disableCheck === true ? " btn-primary" : " btn-secondary"
                }`}
                onClick={handleDisableCheck}
              >
                Check
              </button>
              <button
                type="button"
                className={`btn btn-sm me-1 ${
                  disableGiftCard === true ? " btn-primary" : " btn-secondary"
                }`}
                onClick={handleDisableGiftCard}
              >
                Gift Card
              </button>
              <button
                type="button"
                className={`btn btn-sm me-1 ${
                  disableDebitCard === true ? " btn-primary" : " btn-secondary"
                }`}
                onClick={handleDisableDebitCard}
              >
                Debit Card
              </button>
              <button
                type="button"
                className={`btn btn-sm me-1 ${
                  disableCreditCard === true ? " btn-primary" : " btn-secondary"
                }`}
                onClick={handleDisableCreditCard}
              >
                Credit Card
              </button>
            </div>
            <div className="input-group">
              <Field
                type="text"
                className="form-control form-control-sm"
                id="PaymentTypes"
                name="PaymentTypes"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Cash Markup/Markdown Percentage",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="CashMarkupMarkdownPercentage"
              name="CashMarkupMarkdownPercentage"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Check Markup/Markdown Percentage",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="CheckMarkupMarkdownPercentage"
              name="CheckMarkupMarkdownPercentage"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Gift Card Markup/Markdown Percentage",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="GiftCardMarkupMarkdownPercentage"
              name="GiftCardMarkupMarkdownPercentage"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Debit Card Markup/Markdown Percentage",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="DebitCardMarkupMarkdownPercentage"
              name="DebitCardMarkupMarkdownPercentage"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: " Credit Card Markup/Markdown Percentage",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="CreditCardMarkupMarkdownPercentage"
              name="CreditCardMarkupMarkdownPercentage"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Store Account Markup/Markdown Percentage",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="StoreAccountMarkupMarkdownPercentage"
              name="StoreAccountMarkupMarkdownPercentage"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Points Markup/Markdown Percentage",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="PointsMarkupMarkdownPercentage"
              name="PointsMarkupMarkdownPercentage"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Default Payment Type:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-control-sm form-small select"
              id="DefaultPaymentType"
              name="DefaultPaymentType"
              onChange={handleChange}
            >
              <option>Cash</option>
              <option>Check</option>
              <option>Gift Card</option>
              <option>Debit Card</option>
              <option>Credit Card</option>
              <option>Store Account</option>
              <option>None</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Default Payment Type For Receivings:",
      input: (
        <>
          <div className="input-group">
            <Field
              as="select"
              className="form-control form-control-sm form-small select"
              id="DefaultPaymentTypeForReceivings"
              name="DefaultPaymentTypeForReceivings"
              onChange={handleChange}
            >
              <option>Cash</option>
              <option>Check</option>
              <option>Gift Card</option>
              <option>Debit Card</option>
              <option>Credit Card</option>
              <option>Store Account</option>
              <option>None</option>
            </Field>
          </div>
        </>
      ),
    },
    {
      name: "Show Selling Price On Receiving Receipt:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="ShowSellingPriceOnReceivingReceipt"
              name="ShowSellingPriceOnReceivingReceipt"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Enable EBT Payments:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="EnableEBTPayments"
              name="EnableEBTPayments"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Enable WIC:",
      input: (
        <>
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="EnableWIC"
              name="EnableWIC"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Prompt For CCV When Swiping Credit Card:",
      input: (
        <>
          {" "}
          <div className="input-group">
            <Field
              className="form-check-input"
              style={{ width: "1.5em", height: "1.5em" }}
              type="checkbox"
              id="PromptForCCVWhenSwipingCreditCard"
              name="PromptForCCVWhenSwipingCreditCard"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
  ];

  //filter
  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  handlePayment();
                  setVisiblePaymentTypes(!visiblePaymentTypes);
                  setcomingPaymentTypes(!!comingPaymentTypes);
                }}
              >
                Payment Types
              </CLink>
            </h5>
          </div>
          <CCollapse
            visible={visiblePaymentTypes || props.visiblePaymentTypesChange}
          >
            <div className="card-body">
              <Formik
                {...props}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {() => (
                  <Form>
                    <div className="row">
                      <div
                        style={{
                          display: "flex",
                          width: "50%",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div style={{ width: "53%" }}>{el.input}</div>
                            </div>
                          ))}
                      </div>

                      {/* <label className="col-form-label col-lg-2">
                      Payment Types:
                    </label> */}
                      {/* <div className="col-lg-10">
                      <div className="mb-3">
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableCash === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableCash}
                        >
                          Cash
                        </button>
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableCheck === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableCheck}
                        >
                          Check
                        </button>
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableGiftCard === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableGiftCard}
                        >
                          Gift Card
                        </button>
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableDebitCard === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableDebitCard}
                        >
                          Debit Card
                        </button>
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableCreditCard === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableCreditCard}
                        >
                          Credit Card
                        </button>
                      </div>
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="PaymentTypes"
                          name="PaymentTypes"
                          onChange={handleChange}
                        />
                      </div>
                    </div> */}
                    </div>
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Cash Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CashMarkupMarkdownPercentage"
                          name="CashMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Check Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CheckMarkupMarkdownPercentage"
                          name="CheckMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Gift Card Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="GiftCardMarkupMarkdownPercentage"
                          name="GiftCardMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Debit Card Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DebitCardMarkupMarkdownPercentage"
                          name="DebitCardMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Credit Card Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CreditCardMarkupMarkdownPercentage"
                          name="CreditCardMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Store Account Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="StoreAccountMarkupMarkdownPercentage"
                          name="StoreAccountMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Points Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="PointsMarkupMarkdownPercentage"
                          name="PointsMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Payment Type:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="DefaultPaymentType"
                          name="DefaultPaymentType"
                          onChange={handleChange}
                        >
                          <option>Cash</option>
                          <option>Check</option>
                          <option>Gift Card</option>
                          <option>Debit Card</option>
                          <option>Credit Card</option>
                          <option>Store Account</option>
                          <option>None</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Payment Type For Receivings:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="DefaultPaymentTypeForReceivings"
                          name="DefaultPaymentTypeForReceivings"
                          onChange={handleChange}
                        >
                          <option>Cash</option>
                          <option>Check</option>
                          <option>Gift Card</option>
                          <option>Debit Card</option>
                          <option>Credit Card</option>
                          <option>Store Account</option>
                          <option>None</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show Selling Price On Receiving Receipt:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowSellingPriceOnReceivingReceipt"
                          name="ShowSellingPriceOnReceivingReceipt"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable EBT Payments:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableEBTPayments"
                          name="EnableEBTPayments"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable WIC:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableWIC"
                          name="EnableWIC"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Prompt For CCV When Swiping Credit Card:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="PromptForCCVWhenSwipingCreditCard"
                          name="PromptForCCVWhenSwipingCreditCard"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisiblePaymentTypes(!visiblePaymentTypes);
                    setcomingPaymentTypes(!!comingPaymentTypes);
                  }}
                >
                  Payment Types
                </CLink>
              </h5>
            </div>
            <CCollapse
              visible={visiblePaymentTypes || props.visiblePaymentTypesChange}
            >
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {() => (
                    <Form>
                      <div className="row">
                        <div
                          style={{
                            display: "flex",
                            width: "50%",
                            flexDirection: "column",
                            alignItems: "flex-start",
                          }}
                        >
                          {matchesSearchQuery &&
                            matchesSearchQuery?.map((el) => (
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginTop: "10px",
                                }}
                              >
                                <label
                                  className="col-form-label"
                                  style={{ fontSize: "15px" }}
                                >
                                  {el.name}
                                </label>
                                <div style={{ width: "53%" }}>{el.input}</div>
                              </div>
                            ))}
                        </div>

                        {/* <label className="col-form-label col-lg-2">
                      Payment Types:
                    </label> */}
                        {/* <div className="col-lg-10">
                      <div className="mb-3">
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableCash === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableCash}
                        >
                          Cash
                        </button>
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableCheck === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableCheck}
                        >
                          Check
                        </button>
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableGiftCard === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableGiftCard}
                        >
                          Gift Card
                        </button>
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableDebitCard === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableDebitCard}
                        >
                          Debit Card
                        </button>
                        <button
                          type="button"
                          className={`btn me-1 ${
                            disableCreditCard === true
                              ? "text-decoration-line-through btn-danger"
                              : "btn-primary"
                          }`}
                          onClick={handleDisableCreditCard}
                        >
                          Credit Card
                        </button>
                      </div>
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="PaymentTypes"
                          name="PaymentTypes"
                          onChange={handleChange}
                        />
                      </div>
                    </div> */}
                      </div>
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Cash Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CashMarkupMarkdownPercentage"
                          name="CashMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Check Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CheckMarkupMarkdownPercentage"
                          name="CheckMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Gift Card Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="GiftCardMarkupMarkdownPercentage"
                          name="GiftCardMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Debit Card Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DebitCardMarkupMarkdownPercentage"
                          name="DebitCardMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Credit Card Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="CreditCardMarkupMarkdownPercentage"
                          name="CreditCardMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Store Account Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="StoreAccountMarkupMarkdownPercentage"
                          name="StoreAccountMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Points Markup/Markdown Percentage
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="PointsMarkupMarkdownPercentage"
                          name="PointsMarkupMarkdownPercentage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Payment Type:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="DefaultPaymentType"
                          name="DefaultPaymentType"
                          onChange={handleChange}
                        >
                          <option>Cash</option>
                          <option>Check</option>
                          <option>Gift Card</option>
                          <option>Debit Card</option>
                          <option>Credit Card</option>
                          <option>Store Account</option>
                          <option>None</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Payment Type For Receivings:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="DefaultPaymentTypeForReceivings"
                          name="DefaultPaymentTypeForReceivings"
                          onChange={handleChange}
                        >
                          <option>Cash</option>
                          <option>Check</option>
                          <option>Gift Card</option>
                          <option>Debit Card</option>
                          <option>Credit Card</option>
                          <option>Store Account</option>
                          <option>None</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show Selling Price On Receiving Receipt:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowSellingPriceOnReceivingReceipt"
                          name="ShowSellingPriceOnReceivingReceipt"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable EBT Payments:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableEBTPayments"
                          name="EnableEBTPayments"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable WIC:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableWIC"
                          name="EnableWIC"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Prompt For CCV When Swiping Credit Card:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="PromptForCCVWhenSwipingCreditCard"
                          name="PromptForCCVWhenSwipingCreditCard"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default PaymentTypes;
